import { createRouter, createBrowserHistory } from '@tanstack/react-router';

import { queryClient } from './providers/QueryProvider';
import { routeTree } from './routeTree.gen';
import { AuthenticatedRouteContentSkeleton } from './routes/-components/skeletons';

const browserHistory = createBrowserHistory();

export const router = createRouter({
  routeTree,
  history: browserHistory,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultPendingComponent: AuthenticatedRouteContentSkeleton,
  defaultPendingMs: 0,
  defaultPendingMinMs: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
